import { createAction, props, Action } from '@ngrx/store';

export const APPLY_VOUCHER_CODE_TYPE = '[Checkout] APPLY VOUCHER CODE';
export const discountAPI_applyVoucherCode = createAction(
  APPLY_VOUCHER_CODE_TYPE,
  props<{ basketId: string; voucherCode: string }>()
);

export const discountAPI_applyVoucherCodeSuccess = createAction(
  `${APPLY_VOUCHER_CODE_TYPE} Success`,
  props<{ basketId: string; voucherCode: string }>()
);

export const discountAPI_applyVoucherCodeFailure = createAction(
  `${APPLY_VOUCHER_CODE_TYPE} Failure`,
  props<{ errorMsg: string; voucherCode: string; retryAction?: Action }>()
);

export const REMOVE_VOUCHER_CODE_TYPE = '[Checkout] REMOVE VOUCHER CODE';
export const discountAPI_removeVoucherCode = createAction(
  REMOVE_VOUCHER_CODE_TYPE,
  props<{ basketId: string; voucherCode: string; }>()
);

export const discountAPI_removeVoucherCodeSuccess = createAction(
  `${REMOVE_VOUCHER_CODE_TYPE} Success`,
  props<{ basketId: string; }>()
);

export const discountAPI_removeVoucherCodeFailure = createAction(
  `${REMOVE_VOUCHER_CODE_TYPE} Failure`,
  props<{ errorMsg: string; voucherCode: string; retryAction?: Action }>()
);

export const ASSOCIATE_USER_WITH_BASKET_TYPE = '[Checkout] ASSOCIATE USER WITH BASKET';
export const discountAPI_associateUserWithBasket = createAction(
  ASSOCIATE_USER_WITH_BASKET_TYPE,
  props<{ basketId: string; }>()
);

export const discountAPI_associateUserWithBasketSuccess = createAction(
  `${ASSOCIATE_USER_WITH_BASKET_TYPE} Success`,
  props<{ basketId: string; }>()
);

export const discountAPI_associateUserWithBasketFailure = createAction(
  `${ASSOCIATE_USER_WITH_BASKET_TYPE} Failure`,
  props<{ errorMsg: string; retryAction?: Action }>()
);
